import { render } from "./InviteClientModal.vue?vue&type=template&id=424515d3&scoped=true"
import script from "./InviteClientModal.vue?vue&type=script&lang=js"
export * from "./InviteClientModal.vue?vue&type=script&lang=js"

import "./InviteClientModal.vue?vue&type=style&index=0&id=424515d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424515d3"]])

export default __exports__